import referral from "./referralfaq";
import other from "./otherfaq";
import liquidationfaq from "./liquidationfaq";
import aboutbond from "./aboutbond";
import keertanaIssuer from "./keertanaissuer";
import aboutPtc from "./naviptc-constants/aboutptcs"
import aboutneo from "./neogrowth-constants/aboutneo";
import aboutneo25 from "./neogrowth-constants/aboutneo25";
import aboutspan from "./aboutspan";
import aboutspan25 from "./aboutspan25";
import aboutnavi25 from "./naviptc-constants/aboutnavi25";
import aboutoriginator from "./naviptc-constants/aboutoriginator";
import aboutbondsissuer from "./aboutbondsissuer";
import aboutincred from "./ipomarketingconstants.js/aboutincred";
import aboutincredfin from "./ipomarketingconstants.js/aboutincredfin";
import aboutIPO from "./ipomarketingconstants.js/aboutIPO";
import aboutMLD from "./mldMarketingconstants/aboutMLD";
import aboutbalMLD from "./mldMarketingconstants/aboutbalMLD";
import aboutpricing from "./ipomarketingconstants.js/aboutpricing";
import items from "./whyIcm-constants/items";
import aboutlending from "./lendingkart-constants/aboutlending";
import aboutlending25 from "./lendingkart-constants/aboutlending25";
import aboutincred2 from "./aboutincred2";
import aboutissue2 from "./aboutissue2";
import aboutissue3 from "./aboutissue3";
import aboutissue4 from "./aboutissue4";
import aboutissue5 from "./aboutissue5";
import aboutkb from "./krazyBeeconstants/aboutkb";
import aboutkb25 from "./krazyBeeconstants/aboutkb25";
import aboutAkara from "./akaraCapitalconstants/aboutAkara";
import aboutAkara25 from "./akaraCapitalconstants/aboutAkara25";
import aboutlending2 from "./lendingkart-constants/aboutlending2";
import aboutlendingjan26 from "./lendingkart-constants/aboutLendingJuly25";
import aboutIncredMLD from "./mldMarketingconstants/aboutIncredMLD";
import aboutincredfin1 from "./ipomarketingconstants.js/aboutincredfin1";
import liquidationfaq1 from "./liquidationfaq1";


export const mldInvest = {
  pageTitle: 'Market Linked Debentures - Bidd',
  metaData: {
    keywords: 'Alternate Investment Platform - Best Passive Income Investment',
    description: "Learn more about Market Linked Debentures",
    ogTitle: 'Market Linked Debentures - Bidd',
    ogDescription: "Learn more about Market Linked Debentures",
    ogUrl: process.env.APP_BASE_URL + '/mld',
    ogImgUrl: 'https://s3.ap-south-1.amazonaws.com/production.biddeasy.com/platform/static/images/logo/incred-money.png?timestamp=' + Date.now()
  },

  firstFold: {
    title: "Nifty MLD Jul’25",
    ribbons: [
      {
        text: "Listed"
      },
      {
        text: "Senior Secured"
      },
      {
        text: "Anytime Liquidity",
          popup: `Available at a cost of 2% of the total amount liquidated. Refer <a href='/terms-of-use'>T&C</a> for more details.`
      }      
    ],
    subPoints: [
      {
        point: "Min. Returns",
        explaination: "10%",
        infoic: 'true',
        popOvertext: "popOver text for Min. Returns"
      },
      {
        point: "Max Returns",
        explaination: "30%",
        infoic: 'true',
        popOvertext: "popOver text for Max. Returns"
      },
      {
        point: "Nifty Multiplier",
        explaination: "1.1x",
        infoic: 'true',
        popOvertext: "popOver text for Nifty multiplier"
      },
      {
        point: "Minimum Investment",
        explaination: "Rx. 1,00,000"
      },
      {
        point: "Issue Date",
        explaination: "24th Jul 25",
        // infoic: 'true',
        popOvertext: "popOver text for issue date"
      },
      {
        point: "Maturity Date",
        explaination: "24th Jul 25",
        // infoic: 'true',
        popOvertext: "popOver text for maturity date"
      },
      {
        point: "Credit Rating",
        explaination: "CRISIL A Stable"
      },
      {
        point: "ISIN ",
        explaination: "INE0NES07030"
      },
      {
        point: "Principal Repayment",
        explaination: "Quarterly"
      },
      {
        point: "Returns Payout",
        explaination: "At Maturity"
      },
      {
        point: "Listed",
        explaination: "Yes"
      },
    ],
  },

  secondFold: {
    title: "Why invest in InCred Nifty Balanced MLD Aug'25",
    content: [
      {
        imgSrc: process.env.REACT_APP_IMAGES_PATH + "Vector.webp",
        text: 'Minimum Returns of 14% at Maturity',
        showInfo: true,
        infoText: `The returns are calculated on the Face Value of ₹1,00,000. <b>Maturity Date: 31st August 2025</b>`,
        subtext: 'You will get a minimum return of 14% on your investment even in case of a heavy loss in the Nifty 50 Index. It goes without saying that 100% of the Principal is protected.'
      },
      {
        imgSrc: process.env.REACT_APP_IMAGES_PATH + "Highlight.webp",
        text: 'Mirror Nifty Returns',
        subtext: 'But not the Risk. Participate only in the upside of Nifty and not the downside.'
      },
      {
        imgSrc: process.env.REACT_APP_IMAGES_PATH + "Port.webp",
        text: 'De-risk Portfolio',
        subtext: 'Diversify your portfolio to reduce the overall risk and improve your risk-adjusted returns.',
        seeHow: true,
        popUpImg: process.env.REACT_APP_IMAGES_PATH + "PopUpChart.webp",
        mobileViewImage: process.env.REACT_APP_IMAGES_PATH + "PopUpChart.webp"
      },
    ]

  },

  thirdFoldGoldMld: {
    title: "Why the Magnifier MLD?",
    subTitle:"Looking to boost your returns from the Gold but don’t want any Loss? Then this MLD is for you.",
    content: [
      {
        imgSrc: process.env.REACT_APP_IMAGES_PATH + "Vector.webp",
        text: 'Get Gold linked returns',
        // showInfo: true,
        // infoText: `The returns are calculated on the Face Value of ₹1,00,000. <b>Maturity Date: 31st August 2025</b>`,
        subtext: 'Perfect product to express a reasonably bullish view on Gold. Get 1.3x leveraged participation in gold’s positive performance, from 0% up to a cap of 78%.'
      },
      {
        imgSrc: process.env.REACT_APP_IMAGES_PATH + "Highlight.webp",
        text: ' 100% Principal Protection',
        subtext: ' Even if the Gold gives negative returns on maturity, your principal is protected'
      },
      {
        imgSrc: process.env.REACT_APP_IMAGES_PATH + "Port.webp",
        text: 'De-risk Portfolio',
        subtext: 'Diversify your portfolio to reduce the overall risk and improve your risk-adjusted returns.',
        seeHow: true,
        popUpImg: process.env.REACT_APP_IMAGES_PATH + "PopUpChart.webp",
        mobileViewImage: process.env.REACT_APP_IMAGES_PATH + "PopUpChart.webp"
      },
    ]
  },

    thirdFoldGoldMld1: {
    title: "Why the Twin Win MLD?",
    subTitle:"Looking to boost your returns from the Gold but don’t want any Loss? Then this MLD is for you.",
    content: [
      {
        imgSrc: process.env.REACT_APP_IMAGES_PATH + "Vector.webp",
        text: 'Get Gold-linked returns',
        // showInfo: true,
        // infoText: `The returns are calculated on the Face Value of ₹1,00,000. <b>Maturity Date: 31st August 2025</b>`,
        subtext: 'Product offers best of both worlds: fixed returns on dips and participation on upside.'
      },
      {
        imgSrc: process.env.REACT_APP_IMAGES_PATH + "Highlight.webp",
        text: ' 100% Principal Protection',
        subtext: 'Even if the Gold gives negative returns on maturity, your principal is protected and guaranteed protection at 6.5%'
      },
      {
        imgSrc: process.env.REACT_APP_IMAGES_PATH + "Port.webp",
        text: 'De-risk Portfolio',
        subtext: 'Diversify your portfolio to reduce the overall risk and improve your risk-adjusted returns.',
        seeHow: true,
        popUpImg: process.env.REACT_APP_IMAGES_PATH + "PopUpChart.webp",
        mobileViewImage: process.env.REACT_APP_IMAGES_PATH + "PopUpChart.webp"
      },
    ]
  },

  forthFold: {
    title: "Why the Enhanced MLD?",
    subTitle:"Looking to boost your returns in the Stock Markets but don’t want any Loss? Then this MLD is for you.",
    content: [
      {
        imgSrc: process.env.REACT_APP_IMAGES_PATH + "Vector_1.webp",
        text: '100% Principal Protection',
        subtext: 'Even if the Nifty 50 gives negative returns on maturity, the MLD principal will be intact'
      },
      {
        imgSrc: process.env.REACT_APP_IMAGES_PATH + "Highlight.webp",
        text: 'Get Nifty Linked Returns',
        subtext: 'Perfect product to express a reasonably bullish view on Nifty. MLD provides 1x returns till 10% of NIFTY Performance and super-leveraged NIFTY returns (2x) from 10% to 35%.'
      },
      {
        imgSrc: process.env.REACT_APP_IMAGES_PATH + "Port.webp",
        text: 'De-risk Portfolio',
        subtext: 'Diversify your portfolio to reduce the overall risk and improve your risk-adjusted returns.',
        seeHow: true,
        popUpImg: process.env.REACT_APP_IMAGES_PATH + "enhanced-table.webp",
        mobileViewImage: process.env.REACT_APP_IMAGES_PATH + "enhanced-table.webp"
      },
    ]

  },
  mld5Fold: {
    title: "Why the NIFTY50 MLD?",
    subTitle:"Looking to boost your returns from NIFTY but don’t want any Loss? Then this MLD is for you.",
    content: [
      {
        imgSrc: process.env.REACT_APP_IMAGES_PATH + "Vector_1.webp",
        text: 'Get NIFTY50-linked returns',
        subtext: 'Product offers the best of both worlds: fixed returns on dips and participation on upside'
      },
      {
        imgSrc: process.env.REACT_APP_IMAGES_PATH + "Highlight.webp",
        text: '100% Principal Protection',
        subtext: 'Even if the NIFTY50 gives negative returns on maturity, your principal is protected and maximum loss is 0%'
      },
      {
        imgSrc: process.env.REACT_APP_IMAGES_PATH + "Port.webp",
        text: 'De-risk Portfolio',
        subtext: 'Diversify your portfolio to reduce the overall risk and improve your risk-adjusted returns.',
        seeHow: true,
        popUpImg: process.env.REACT_APP_IMAGES_PATH + "enhanced-table.webp",
        mobileViewImage: process.env.REACT_APP_IMAGES_PATH + "enhanced-table.webp"
      },
    ]

  },
  wantToKnowHowFold: {
    title: "Want to know how 100% Principal is protected at maturity?",
    clickHere: true,
    popUpImg: process.env.REACT_APP_IMAGES_PATH + "PopUpChart2.webp",
    mobilePopUpImg: process.env.REACT_APP_IMAGES_PATH + "PopUpChart2Mobile.webp"
  },

  wantToKnowHowFoldMld5: {
    title: "Want to know how 100% Principal is protected at maturity?",
    clickHere: true,
    popUpImg: process.env.REACT_APP_IMAGES_PATH + "PopUpChartMld5.webp",
    mobilePopUpImg: process.env.REACT_APP_IMAGES_PATH + "PopUpChart2MobileMld5.webp"
  },

  wantToKnowHowFold2: {
    title: "Want to know how 100% Principal is protected at maturity?",
    clickHere: true,
    popUpImg: process.env.REACT_APP_IMAGES_PATH + "mldReturnsWeb.webp",
    mobilePopUpImg: process.env.REACT_APP_IMAGES_PATH + "mldReturnsMob.webp"
  },
  wantToKnowHowFoldGoldTwin: {
    title: "Want to know how 100% Principal is protected at maturity?",
    clickHere: true,
    popUpImg: process.env.REACT_APP_IMAGES_PATH + "Twin+Win+MLD+100%25+.png",
    mobilePopUpImg: process.env.REACT_APP_IMAGES_PATH + "Twin+Win+MLD+visual+mobile.png"
  },
  riskFold: {
    title: "What are the risks involved?",
  },
  thirdFold: {
    title: "How Much Return will I get?",
    subPoints: [
      {
        subtext: "The MLD will give you returns in two ways:",
        explaination1: "Fixed – The MLD has a minimum and Fixed return of 10%",
        explaination2: "Participating – The MLD will have participation in the gains of Nifty (and not losses) with a multiplier of 1.1x. A 10% return on Nifty would mean an 11% Return on the MLD."

      },
    ],
    subheading3: "The Total return of the MLD would be the Sum of Fixed & Floating with a Maximum Returns of 30%. Hence, Minimum Returns – 10%; Maximum Returns – 30%",
    subHeading: "Estimate your returns",
    subHeading2: "An Illustrative example",
    imgsrc: process.env.REACT_APP_IMAGES_PATH + "Graph1.webp"
  },
  
  aboutIncred: {
    title: "InCred Financial Services Ltd.",
    imgSrc: "/platform/static/images/mld/aboutICM.png",
    descTitle: "<b>Nature of Business:</b> Diversified NBFC",
    description: "InCred Financial Services Ltd. is a new-age financial services platform leveraging technology and data science in its lending business. IFSL is registered with the RBI as a systemically important NBFC.", 
    parameters: [
      {
        key: "AUM",
        value: "₹ 6,100 Crs"
      },
      {
        key: "Net Worth",
        value: "₹ 2,500 Crs"
      },
      {
        key: "Profit Before Tax",
        value: "₹ 200 Crs"
      },
      {
        key: "GNPA / NNPA",
        value: "2.1% / 0.9%"
      }
    ]
  },
  
  stats: {
    title: "Join our community of 1.5+ lakh users",
    statsItems: [
      {
        img: process.env.REACT_APP_IMAGES_PATH + "Money.webp",
        title: "₹1,250+ Cr",
        subtext: "AUM (Assets Under Management)"
      },
      {
        img: process.env.REACT_APP_IMAGES_PATH + "Defaults.webp" ,
        title: "10-12% XIRR",
        subtext: "Avg returns (p.a.) earned"
      },
      {
        img: process.env.REACT_APP_IMAGES_PATH + "WrongMark.webp",
        title: "0",
        subtext: "Defaults till date"
      },
      {
        img: process.env.REACT_APP_IMAGES_PATH + "newGroup.webp",
        title: "100%",
        subtext: "On-time payments"
      }
    ]
  },

  workFlow: {
    title: "Simple to earn, How it works?",
    content: [
      {
        imgSrc: process.env.REACT_APP_IMAGES_PATH + "refer1.webp",
        text: 'Step 1',
        subtext: 'Refer your friend by sending an email invite or by directly sharing your referral invitation link'
      },
      {
        imgSrc: process.env.REACT_APP_IMAGES_PATH + "refer2.webp",
        text: 'Step 2',
        subtext: 'Your friend signs up using your referral invitation link and starts investing	'
      },
      {
        imgSrc: process.env.REACT_APP_IMAGES_PATH + "refer3.webp",
        text: 'Step 3',
        subtext: 'l incentive of ₹1,000 on completion of your friend’s 1st investment plus 1% (Festive Offer) of the amount invested by your friend over the year'
      },
    ]

  },

  whyIcm: {
    title: "What we like about InCred Financials & the issue?",
    ...items,
    
  },
 
  faqRefer: [
    {
      question: "What is considered as a successful referral?",
      answer: "Successful referral is considered only when your friend signs up on Bidd using your referral code or link. You will start earning when the friend makes an investment and continue to earn till 1 year from the friend's date of sign up."
    },
    {
      question: "Is there any limit to how much I can earn?",
      answer: "Yes, there is a maximum cap of ₹26,000 earnings per referral. This cap is only for a single user referred by you. For example: if you refer 5 of your friends, your maximum earning will be up to ₹1,30,000 (₹26,000*5)."
    },
  
    {
      question: "How and when is the referral incentive paid out?",
      answer: "Referral incentives are paid out in the form of Amazon vouchers by the 10th of every month for the previous month's earnings."
    },
    {
      question: "When does the first year start for referral incentive?",
      answer: "The referral incentives apply for up to 1 year from the date of the friend's signup"
    },
    {
      question: "If my friend invests multiple times on the same bond or MLD, will I be eligible for the incentive on all transactions?",
      answer: "Yes, you continue to earn incentives for all investments done by your friend up to 1 year of his/her signup on Bidd."
    },
    {
      question: "How can I track my referral incentive?",
      answer: "You can track it by clicking on the 'View Referral Dashboard' link above."
    },
  
    {
      question: "I have queries about my referral incentive, who do I reach out to?",
      answer: "You can reach out to our customer support team on +91-85918 71028/+91-8928250817 or mail us on <a href='mailto:connect@biddeasy.com'>connect@biddeasy.com</a>"
    },
  ],
  mldMarketingFaq: {
    ...aboutMLD,
    ...aboutbalMLD,
    ...aboutincredfin,
    ...aboutpricing,
    ...liquidationfaq,
    ...referral,
    ...other,
  },

  mld3: {
    ...aboutMLD,
    ...aboutIncredMLD,
    ...aboutincredfin1,
    ...liquidationfaq1,
    ...aboutpricing,
    ...referral,
    ...other,

  },

  ipoMarketingFaq: {
    ...aboutincred,
    ...aboutincredfin,
    ...liquidationfaq,
    ...aboutIPO,
    ...other,
  },

  span0: {
    ...aboutspan,
    ...aboutspan25,
    ...liquidationfaq,
    ...referral,
    ...other,
  },
  neo0: {
    ...aboutneo,
    ...aboutneo25,
    ...liquidationfaq,
    ...referral,
    ...other,
  },
  neo1: {
    ...aboutneo,
    ...aboutneo25,
    ...liquidationfaq,
    ...referral,
    ...other,
  },
  naviptc0: {

    ...aboutPtc,
    ...aboutnavi25,
    ...aboutoriginator,
    ...liquidationfaq,
    ...referral,
    ...other,
  },
  naviptc1: {

    ...aboutPtc,
    ...aboutnavi25,
    ...aboutoriginator,
    ...liquidationfaq,
    ...referral,
    ...other,
  },
  keertana1: {
    ...aboutbond,
    ...keertanaIssuer,
    ...liquidationfaq,
    ...referral,
    ...other,
  },
  keertana2: {
    ...aboutbond,
    ...keertanaIssuer,
    ...liquidationfaq,
    ...referral,
    ...other,
  },
  keertana0: {
    ...aboutbond,
    ...keertanaIssuer,
    ...liquidationfaq,
    ...referral,
    ...other,
  },

  lendingkart0: {
    ...aboutlending,
    ...aboutlending25,
    ...liquidationfaq,
    ...referral,
    ...other,
  },

  lendingkart1: {
    ...aboutlending,
    ...aboutlending25,
    ...liquidationfaq,
    ...referral,
    ...other,
  },

  lendingkart2: {
    ...aboutlending2,
    ...aboutlendingjan26,
    ...liquidationfaq,
    ...referral,
    ...other,
  },

  icifin2:
  {
    ...aboutincred2,
    ...aboutissue2,
    ...liquidationfaq,
    ...referral,
    ...other,
  },

  icifin3:
  {
    ...aboutincred2,
    ...aboutissue3,
    ...liquidationfaq,
    ...referral,
    ...other,
  },

  icifin4:
  {
    ...aboutincred2,
    ...aboutissue4,
    ...liquidationfaq,
    ...referral,
    ...other,
  },

  icifin5:
  {
    ...aboutincred2,
    ...aboutissue5,
    ...liquidationfaq,
    ...referral,
    ...other,
  },

  kb0:
  {
    ...aboutkb,
    ...aboutkb25,
    ...liquidationfaq,
    ...referral,
    ...other,
  },
  kb1:
  {
    ...aboutkb,
    ...aboutkb25,
    ...liquidationfaq,
    ...referral,
    ...other,
  },
  
  kb2:
  {
    ...aboutkb,
    ...aboutkb25,
    ...liquidationfaq,
    ...referral,
    ...other,
  },
  
  kb3:
  {
    ...aboutkb,
    ...aboutkb25,
    ...liquidationfaq,
    ...referral,
    ...other,
  },

  ac0:
  {
    ...aboutAkara,
    ...aboutAkara25,
    ...liquidationfaq,
    ...referral,
    ...other,
  },
  ac1:
  {
    ...aboutAkara,
    ...aboutAkara25,
    ...liquidationfaq,
    ...referral,
    ...other,
  },
  ac2:
  {
    ...aboutAkara,
    ...aboutAkara25,
    ...liquidationfaq,
    ...referral,
    ...other,
  },
  
  bondsMarketingFaq: {
    ...aboutbond, 
    ...aboutbondsissuer,
    ...liquidationfaq,
    ...referral,
    ...other,
  }
}
